import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as pullRequest from '../pull-request'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: pullRequest.RESOURCE.payload.dimension.partialId,
      partialId: pullRequest.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'in review, changes requested, or approved, from the latest review.',
    isOptional: true,
    name: 'Review State',
    partialId: PartialId.Standard.create('review_state'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.pullRequestReviewState.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
